/*#__PURE__*/ export default JSON.parse('{"key":"homePageAvantgarde","type":"root","items":[]}');